// @flow strict
import * as React from 'react';
import type { GroupToursBySection } from '../../records/Tour.js';
import type { Poi } from '../../records/Poi.js';
import type { PoiContent } from '../../records/PoiContent.js';
import type { ObservationDeck } from '../../records/ObservationDeck.js';
import type { Language } from '../intl/context.js';
import { createEmptyPoisByLocale } from '../localeDefaults.js';

export type PoiContextType = {
  poi: { [Language]: Poi },
  tours: GroupToursBySection,
  poiContent: ?PoiContent,
  observationDecks: ObservationDeck[],
  popularAttractions: Poi[],
};

const PoiContext = React.createContext<PoiContextType>({
  poi: createEmptyPoisByLocale(),
  tours: {},
  poiContent: null,
  observationDecks: [],
  popularAttractions: [],
});

export default PoiContext;
